
import { Routes } from '@angular/router';
import { UserListComponent } from '../components/user-list/user-list.component';
import { PlaylistsComponent } from '../components/playlists/playlists.component';
import { VideosComponent } from '../components/videos/videos.component';

export const routes: Routes = [
  { path: 'users', component: UserListComponent },
  { path: 'playlists', component: PlaylistsComponent},
  { path: 'videos', component: VideosComponent},
  { path: '', redirectTo: 'playlists', pathMatch: 'full' }
];
